/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Rating } from '../../content/Rating'
import { LanguageHelp, isAllFilter } from '../../../helpers/LanguageHelper'
import { Link } from 'react-router-dom'
import { getHappinessScore } from '../../../helpers/utility'
import { useThemeMode } from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

type Props = {
  uniqueKey: string
  className: string
  datas?: TablesWidget5Dto
  firstColor?: string
  secondColor?: string
  thirdColor?: string
  mainLabel?: string
  sideLabel?: string
  functionDownload?: any
  isDownloadContinue?: boolean
  url?: string
  selectedOption?: string
  selectedChannelType?: string
  selectedDate?: string
  chartSize?: number
  warnings: { url: string, message: string }[]
  isWaringImageMirror?: boolean

  filter_Date: string
  filter_ChannelType: string
  filter_SourceType: string
  filter_Competitor: string
}

export class TablesWidget5ItemDto { id = ""; label = ""; firstCount = 0; secondCount = 0; thirdCount = 0; fourthCount = 0; firstRate = 0; secondRate = 0; thirdRate = 0; fourthRate = 0; image = ""; url = ""; type = 1; isCompetitor = false }

export class TablesWidget5Dto { items: TablesWidget5ItemDto[] = [new TablesWidget5ItemDto]; totalCount = 0; totalRate = 0; }

const TablesWidget5: React.FC<Props> = ({
  uniqueKey,
  className,
  datas = new TablesWidget5Dto(),
  mainLabel = "Your Statistics",
  sideLabel = "",
  functionDownload,
  isDownloadContinue = false,
  url = "",
  selectedOption = LanguageHelp('All'),
  selectedChannelType = LanguageHelp('All Platforms'),
  selectedDate = LanguageHelp('Last 30 days'),
  chartSize = 90,
  warnings = [],
  isWaringImageMirror = false,

  filter_Date = "",
  filter_ChannelType = "",
  filter_SourceType = "",
  filter_Competitor = "",
}) => {

  const { mode } = useThemeMode()
  const [currentItems, setCurrentItems] = useState([new TablesWidget5ItemDto()]);
  const [sorting, setSorting] = useState({ key: 'totalCount', ascending: false })

  function applySorting(key: string) {
    let ascending = false;
    if (key === sorting.key) { ascending = !sorting.ascending }
    setSorting({ key: key, ascending: ascending });

    const currentItemsCopy = [...datas.items];
    if (key === "label") { setCurrentItems(currentItemsCopy.sort((a, b) => sortByText(a, b, ascending))) }
    else if (key.indexOf("Count") > 0) { setCurrentItems(currentItemsCopy.sort((a, b) => sortByNum(a, b, ascending, key))) }
  }

  function sortByNum(a: any, b: any, ascending: boolean, column: string) {
    let diff = 0;

    if (column === "firstCount") { diff = a.firstCount - b.firstCount }
    if (column === "secondCount") { diff = a.secondCount - b.secondCount }
    if (column === "thirdCount") { diff = a.thirdCount - b.thirdCount }
    if (column === "fourthCount") { diff = a.fourthCount - b.fourthCount }

    if (ascending === true) { return diff; }
    return -1 * diff;
  }

  function sortByText(a: any, b: any, ascending: boolean) {
    const diff = a.label.toLowerCase().localeCompare(b.label.toLowerCase());
    if (ascending === true) { return diff; }
    return -1 * diff;
  }

  useEffect(() => {
    setSorting({ key: "firstCount", ascending: false });
    setCurrentItems(datas.items)
  }, [datas]);

  return (
    <div className={`card ${className} minh-md-600px`} key={uniqueKey}>
      {/* begin::Header */}
      <div className='card-header pt-5'>
        <div className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>{mainLabel}</span>
          <div>
            <span className='text-gray-400 fw-semibold fs-6'>{sideLabel}:</span>
            {datas.totalCount !== 0 &&
              <div style={{ display: 'unset' }}>
                <span className='card-label fw-bolder text-gray-700 mt-2 pt-1'>{datas.totalCount}</span>
                <Rating rate={datas.totalRate} />
              </div>
            }
          </div>
        </div>
        <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
                path='/media/icons/duotune/arrows/arr044.svg'
                className='svg-icon-3'
              />
            )}
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
      {/* end::Header */}

      {datas.totalCount === -1 &&
        <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
          <div className='d-flex flex-center me-5 pt-2'>
            <span className='indicator-progress' style={{ display: 'block', margin: 'auto' }}>
              {/* Please wait...{' '} */}
              <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
              <div
                style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
              ></div>
            </span>
          </div>
        </div>
      }

      {(datas.totalCount === 0) && (
        <div className='text-center p-11'>
          {warnings.map((warning, key) => (
            <Link key={key} to={warning.url}>
              <div>
                {warning.message}
                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
              </div>
            </Link>
          ))}
          <div>
            <img
              className='mw-100 mh-200px'
              alt='metronic'
              style={{ transform: isWaringImageMirror ? 'scaleX(-1)' : 'scaleX(1)' }}
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
            />
          </div>
        </div>
      )}

      {datas.totalCount !== -1 && datas.totalCount !== 0 && (
        <div className='card-body py-0 scroll-y mh-450px maxh-md-600px'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>
                {/* begin::Table */}
                <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead className='sticky-table-head'>
                    <tr className=''>
                      <th className={sorting.key === 'label' ? (sorting.ascending === true ? 'fw-bolder text-muted table-sort-asc' : 'fw-bolder text-muted table-sort-desc') : 'fw-bolder text-muted'}
                        style={{ cursor: 'pointer', backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }} onClick={() => applySorting('label')}>{LanguageHelp("Channel")}</th>
                      <th className={sorting.key === 'firstCount' ? (sorting.ascending === true ? 'fw-bolder text-muted table-sort-asc' : 'fw-bolder text-muted table-sort-desc') : 'fw-bolder text-muted'}
                        style={{ cursor: 'pointer', backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }} onClick={() => applySorting('firstCount')}>{LanguageHelp("Total")}</th>
                      <th className='fw-bolder text-muted' style={{ backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }}>{LanguageHelp('Happiness Score')} %</th>
                      <th className={sorting.key === 'secondCount' ? (sorting.ascending === true ? 'fw-bolder text-muted table-sort-asc' : 'fw-bolder text-muted table-sort-desc') : 'fw-bolder text-muted'}
                        style={{ cursor: 'pointer', backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }} onClick={() => applySorting('secondCount')}>{LanguageHelp("Positive")}</th>
                      <th className={sorting.key === 'thirdCount' ? (sorting.ascending === true ? 'fw-bolder text-muted table-sort-asc' : 'fw-bolder text-muted table-sort-desc') : 'fw-bolder text-muted'}
                        style={{ cursor: 'pointer', backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }} onClick={() => applySorting('thirdCount')}>{LanguageHelp("Negative")}</th>
                      <th className={sorting.key === 'fourthCount' ? (sorting.ascending === true ? 'fw-bolder text-muted table-sort-asc' : 'fw-bolder text-muted table-sort-desc') : 'fw-bolder text-muted'}
                        style={{ cursor: 'pointer', backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }} onClick={() => applySorting('fourthCount')}>{LanguageHelp("Neutral")}</th>
                      <th className='' style={{ backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }}></th>
                      <th className='' style={{ backgroundColor: (mode === 'light' ? '#fff' : '#1e1e2d') }}></th>
                    </tr>
                  </thead>
                  {/* end::Table head */}
                  {/* begin::Table body */}
                  <tbody>
                    {currentItems.map((data, index) => (
                      <tr key={uniqueKey + '_' + index}>
                        <td>
                          <div className='d-flex align-items-center'>
                            {/* begin:: Avatar */}
                            <div className='symbol symbol-50px overflow-hidden me-3'>
                              <a href={data.url + 'filter_channel=' + data.id + ((isAllFilter(selectedOption, 'All Subjects')) ? "" : '&filter_subject=' + selectedOption) + '&filter_date=' + filter_Date + '&filter_channeltype=' + filter_ChannelType + '&filter_sourcetype=' + filter_SourceType + '&filter_competitor=' + filter_Competitor}>
                                <div className='symbol-label' style={{ backgroundColor: 'transparent' }}>
                                  <img src={toAbsoluteUrl(data.image)} className='w-100' />
                                </div>
                              </a>
                            </div>
                            <div className='d-flex flex-column'>
                              <a href={data.url + 'filter_channel=' + data.id + ((isAllFilter(selectedOption, 'All Subjects')) ? "" : '&filter_subject=' + selectedOption) + '&filter_date=' + filter_Date + '&filter_channeltype=' + filter_ChannelType + '&filter_sourcetype=' + filter_SourceType + '&filter_competitor=' + filter_Competitor} className='text-gray-800 text-hover-primary mb-1'>
                                {data.label}
                              </a>
                            </div>
                          </div>
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.firstCount}
                          <Rating rate={data.firstRate} />
                        </td>
                        <td className='text-dark fw-bold mb-1'>
                          {getHappinessScore(data.secondCount, data.thirdCount)}
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.secondCount}
                          <Rating rate={data.secondRate} />
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.thirdCount}
                          <Rating rate={data.thirdRate} reversed={true} />
                        </td>
                        <td className='text-dark fw-bold mb-1'>{data.fourthCount}
                          <Rating rate={data.fourthRate} />
                        </td>

                        {data.url !== "" &&
                          <td className='text-end'>
                            <a href={data.url + 'filter_channel=' + data.id + ((isAllFilter(selectedOption, 'All Subjects')) ? "" : '&filter_subject=' + selectedOption) + '&filter_date=' + filter_Date + '&filter_channeltype=' + filter_ChannelType + '&filter_sourcetype=' + filter_SourceType + '&filter_competitor=' + filter_Competitor} className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'>
                              <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                            </a>
                          </td>
                        }

                      </tr>
                    ))}
                  </tbody>
                  {/* end::Table body */}
                </table>
              </div>
              {/* end::Table */}
            </div>
            {/* end::Tap pane */}
          </div>
        </div>
      )}
    </div>
  )
}

export { TablesWidget5 }
